import React, {useEffect, useRef, useState} from "react";
import "./CollapsibleContainer.scss"
import {Button, Icon} from "semantic-ui-react";

/**
 * This is a reusable container that has been designed to collapse/expand on the click of the button. Also, it takes the
 * height of the child element it renders.
 * There is an associated stylesheet for this component and is advised that if there are specific requirements
 * where this is going to be used, we create those classes in that file.
 *
 * @param open - This sets a default bool value of the container, whether at render time it needs to be open or not.
 * @param children - Content that this container will hold.
 * @param title - Title of the part on the UI where this will be used.
 * @returns {JSX.Element}
 * @constructor
 */

export default function CollapsibleContainer ({ open, children, title }) {
    const [isOpen, setIsOpen] = useState(open);
    const [height, setHeight] = useState(0);

    const handleFilterOpening = () => {
        setIsOpen((prev) => !prev);
    };

    const ref = useRef();

    useEffect(() => {
        if (!height || !isOpen || !ref.current) return undefined;
        const resizeObserver = new ResizeObserver((el) => {
            setHeight(el[0].contentRect.height);
        });
        resizeObserver.observe(ref.current);
        return () => {
            resizeObserver.disconnect();
        };
    }, [height, isOpen]);

    useEffect(() => {
        if (isOpen) setHeight(ref.current?.getBoundingClientRect().height);
        else setHeight(0);
    }, [isOpen]);

    return (
        <div className="collapsible-container">
            <div>
                <div className={"collapsible-container-header"} onClick={handleFilterOpening}>
                    <Button
                    >
                        {!isOpen ? (<Icon name={"plus square outline"} />) : (<Icon name={"minus square outline"} />)}
                    </Button>
                    <h6 className={"collapsible-container-title"}>{title}</h6>
                </div>
            </div>

            <div className="collapsible-content" style={{ height }}>
                <div ref={ref}>
                    <div className="collapsible-content-padding">{children}</div>
                </div>
            </div>
        </div>
    );
};
